import thuFavicon from '@/assets/img/logo-thu.png';
import swjtuFavicon from '@/assets/logo/SWJTU.png';
import coalFavicon from '@/assets/logo/coal.png';

/**
 * 路由切换时根据用户来源更新浏览器品牌图标。
 */
export function updateFavicon() {
  const from = localStorage.getItem('from');
  const link = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
  if (link) {
    if (from === 'thu') {
      link.href = thuFavicon;
    } else if (from === 'SWJTU') {
      link.href = swjtuFavicon;
    } else if (from === 'coal') {
      link.href = coalFavicon;
    } else {
      link.href = '/favicon.ico';
    }
  }
}
